import React from 'react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { RefIdChip } from '../ReportUnavailable/RefIdChip';

export function Error({ className, requestId }) {
  return (
    <Box className={className}>
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100%"
        margin="20px"
        data-testid="report-error"
      >
        <Typography
          style={{
            fontSize: '24px',
            fontWeight: '600',
            marginBottom: '12px',
            textAlign: 'center',
          }}
        >
          Error loading info. Try again later
        </Typography>
        <Typography
          style={{
            fontSize: '13px',
            color: '#555',
            marginBottom: '12px',
            textAlign: 'center',
            maxWidth: '420px',
          }}
        >
          If you contact support, please share the reference id below.
        </Typography>
        <RefIdChip requestId={requestId} testIdPrefix="report-error" />
      </Box>
    </Box>
  );
}

Error.propTypes = {
  className: PropTypes.string,
  requestId: PropTypes.string,
};

Error.defaultProps = {
  className: undefined,
  requestId: null,
};
